import { connect } from "react-redux";
import { compose } from "redux";
import RoomPhoto from "./RoomPhoto";
import { getBaseUrlSelector, getUserRoleSelector } from "../../../globalState/app/selectros";


const mapStateToProps = (state) => {
  return {
    roomIdByProps: state.objectRoomEdit?.roomMain?.id,
    baseUrl: getBaseUrlSelector(state),
    userRole: getUserRoleSelector(state),
  }
};

export default compose(connect(mapStateToProps))(RoomPhoto);
